import React from 'react';
import { MapContainer, TileLayer, Marker, Popup, Tooltip } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

const redIcon = new L.Icon({
    iconUrl: 'https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-red.png',
    shadowUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png',
    iconSize: [25, 41],
    iconAnchor: [12, 41],
    popupAnchor: [1, -34],
    shadowSize: [41, 41],
});

const Map = () => {
    const position = [32.165944, 74.179944];
    return (
        <div className="d-flex justify-content-center align-items-center" style={{height: '100vh', width: '100vw'}}>
            <div className="custom-map">
                <MapContainer center={position} zoom={15} style={{ height: '100%', width: '100%' }}>
                    <TileLayer attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors' url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"/>
                    <Marker position={position} icon={redIcon}>
                        <Popup>SKS Fans Pvt Ltd</Popup>
                        <Tooltip permanent direction="top" offset={[15, 30]} className="custom-tooltip">SKS Fans Pvt Ltd</Tooltip>
                    </Marker>
                </MapContainer>
            </div>
        </div>
    );
};
export default Map;
